module.exports = "https://coursera_assets.s3.amazonaws.com/images/67588f79d9a4f646af88536482463249.png";